package com.example.nihulkavapp.Backend.Network

import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext
import myName

abstract class JsCoroutinesAsyncTask<Result>{

    var status: Status = Status.PENDING
    abstract suspend fun doInBackground(): Result
    open fun onPostExecute(result: Result?) {}
    open fun onPreExecute() {}
    open fun onCancelled(result: Result?) {}
    protected var isCancelled = false
    @myName("execute")
    fun execute(){

        if (status != Status.PENDING) {
            when (status) {
                Status.RUNNING -> throw IllegalStateException("Cannot execute task:" + " the task is already running.")
                Status.FINISHED -> throw IllegalStateException("Cannot execute task:"
                        + " the task has already been executed "
                        + "(a task can be executed only once)")
                else -> {}
            }
        }

        status = Status.RUNNING

        // it can be used to setup UI - it should have access to Main Thread
        GlobalScope.launch(Dispatchers.Main){
            onPreExecute()
        }
        console.log("befoore do in back")
        // doInBackground works on background thread(default)
        GlobalScope.launch(Dispatchers.Default){
            console.log("in do in back")
            // Throwable, not Exception: a raw JS error thrown anywhere under
            // doInBackground is a Throwable that fails an `is Exception` check, so
            // subclass catch blocks let it through. Escaping here used to kill this
            // coroutine before onPostExecute ran, and the JS caller waits on a
            // Promise that only onPostExecute settles — so the call hung forever
            // instead of failing, with nothing but an uncaught coroutine exception
            // in the console.
            val result: Result? = try {
                doInBackground()
            } catch (e: Throwable) {
                console.error("task failed: " + e.toString())
                console.error(e.stackTraceToString())
                null
            }
            status = Status.FINISHED
            try {
                withContext(Dispatchers.Main){
                    // onPostExecute works on main thread to show output
                    if (!isCancelled){onPostExecute(result)}
                }
            } catch (e: Throwable) {
                // onPostExecute calls back into JS, so the same rule applies here.
                console.error("task callback failed: " + e.toString())
                console.error(e.stackTraceToString())
            }
        }
    }

    fun cancel(mayInterruptIfRunning : Boolean){
        isCancelled = true
        status = Status.FINISHED
        GlobalScope.launch(Dispatchers.Main){
            // onPostExecute works on main thread to show output
            onPostExecute(null)
        }
    }
}
enum class Status {
    PENDING,
    RUNNING,
    FINISHED
}